import { createOption } from 'utils/form';

import type LabelValue from 'commons/modules/label-value';
import type { Income } from 'commons/modules/service/catalog-income';
import type { ClientAndInvestmentAccount } from 'api/client/models';
import { MissingPolicy } from 'commons/modules/service/risks';

import { PERSON_TYPE } from 'constants/globals';

import type { CatalogLabelValue } from './types';

const isPublicServant = [
  createOption({ label: 'Si', value: 'true' }),
  createOption({ label: 'No', value: 'false' }),
];
const usTaxResidenceOptions = [
  { label: 'Sí', value: true },
  { label: 'No', value: false },
];

const demoBeneficiary = {
  beneficiaryName: '',
  beneficiaryFathersLastName: '',
  beneficiaryMothersLastName: '',
  percentage: '',
  relationship: '',
  birthDate: '',
  rfc: '',
  countryOfOrigin: '',
  nationality: '',
};

const demoShareholder = {
  personType: '',
  businessName: '',
  birthDate: '',
  rfc: '',
  shareHoldingPercentage: '',
};

const demoMember = {
  memberName: '',
  memberFathersLastName: '',
  memberMothersLastName: '',
  memberBirthDate: '',
  memberNationality: '',
  memberRfc: '',
  memberPosition: '',
};

const demoLegalRepresentative = {
  rfc: '',
  curp: '',
  birthDate: '',
  name: '',
  fathersLastName: '',
  mothersLastName: '',
  gender: '',
  birthCountry: '',
  birthState: '',
  nationality: '',
  profession: '',
  currentPosition: '',
  cellPhone: '',
  homePhone: '',
  companyPhone: '',
  email1: '',
  publicDeedNum: '',
  notary: '',
  signatureType: '',
  areaStreet: '',
  areaExteriorNumber: '',
  areaInteriorNumber: '',
  zipCode: '',
  areaSuburb: '',
  cveLocation: '',
  areaCity: '',
  areaState: '',
  cvePais: '',
};

export const personTypes: LabelValue[] = [
  { label: 'Persona física', value: PERSON_TYPE.fisica },
  { label: 'Persona moral', value: PERSON_TYPE.moral },
];

const personType = [
  { label: 'Moral', id: Number(PERSON_TYPE.moral) },
  { label: 'Física', id: Number(PERSON_TYPE.fisica) },
];

export const clientAcounts: {
  label: string;
  value: ClientAndInvestmentAccount[];
} = {
  label: 'clientAcounts',
  value: [],
};

export const instrumentsIncome: { label: string; value: Income[] } = {
  label: 'instrumentsIncome',
  value: [],
};

export const instrumentsIncomeAll: CatalogLabelValue = {
  label: 'instrumentsIncomeAll',
  value: [],
};

export const marketTypes: LabelValue[] = [
  { label: 'Mercado Accionario', value: 'RV' },
  { label: 'Mercado Deuda', value: 'RF' },
];

export const classifications: LabelValue[] = [
  { label: 'Abono afecta', value: 'EFE_EXT_ABONO' },
  { label: 'Abono no afecta', value: 'EFE_INT_ABONO' },
  { label: 'Cargo afecta', value: 'EFE_EXT_CARGO' },
  { label: 'Cargo no afecta', value: 'EFE_INT_CARGO' },
];

export const fees: LabelValue[] = [
  { label: 'Mensual', value: '1' },
  { label: 'Trimestral', value: '2' },
  { label: 'Semestral', value: '3' },
  { label: 'Anual', value: '4' },
];

export const paymentTypes: LabelValue[] = [
  { label: 'Porcentaje', value: '1' },
  { label: 'Monto', value: '2' },
  { label: 'Desempeño', value: '3' },
];

export const clientTypes: LabelValue[] = [
  {
    label: 'Institucional',
    value: '201',
  },
  {
    label: 'Calificado',
    value: '202',
  },
  {
    label: 'Sofisticado',
    value: '203',
  },
  {
    label: 'Ninguno de los anteriores',
    value: '204',
  },
];

export const loadFileStatus = [
  { label: 'Exitoso', value: 'C' },
  { label: 'Pendiente', value: 'LC' },
  { label: 'En proceso', value: 'P' },
  { label: 'Con errores', value: 'E' },
  { label: 'Borrado', value: 'D' },
];

export const nationalities: LabelValue[] = [
  { label: 'Extranjera', value: 'E' },
  { label: 'Nacional', value: 'N' },
];

export const missingPolicyOptions = [
  { value: MissingPolicy.BLOCK, label: 'Bloquear' },
  { value: MissingPolicy.DEFAULT_SCORE, label: 'Puntaje predeterminado' },
  {
    value: MissingPolicy.DEFAULT_NEXT_CATALOG,
    label: 'Catálogo siguiente',
  },
];

export const productProfiles: LabelValue[] = [
  { label: 'Minimo', value: 'MIN' },
  { label: 'Bajo', value: 'LOW' },
  { label: 'Medio', value: 'MEDIUM' },
  { label: 'Alto', value: 'HIGH' },
];

const staticCatalogs = {
  isPublicServant,
  usTaxResidenceOptions,
  personType,
  demoBeneficiary,
  demoShareholder,
  demoMember,
  demoLegalRepresentative,
};

export { staticCatalogs };
